import { motion } from "framer-motion";
import { Star } from "lucide-react";

const reviews = [
  {
    quote: "The Butter Chicken Proppadoms are dangerous. Ordered on Friday, gone by Saturday.",
    name: "Priya S.",
    detail: "Leicester",
  },
  {
    quote: "Proper pub-quality snacks at home. The mango chutney is the best I've had, full stop.",
    name: "Dan W.",
    detail: "Manchester",
  },
  {
    quote: "We put the mixed case on the bar and it outsells crisps two to one. Easy reorder too.",
    name: "The Crown & Anchor",
    detail: "Trade customer",
  },
];

export const Reviews = () => (
  <section className="py-24 lg:py-32" data-testid="reviews-section">
    <div className="max-w-[1440px] mx-auto px-4 sm:px-8 lg:px-12">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7 }}
        className="mb-12"
      >
        <p className="inline-block bg-white border border-[#2B0B3C]/15 rounded-full px-5 py-2 text-xs font-bold tracking-[0.15em] uppercase text-[#2B0B3C]/70 mb-6">
          Word on the street
        </p>
        <h2 className="font-display text-4xl sm:text-5xl font-bold uppercase tracking-tight leading-[0.95] text-[#2B0B3C]">
          People are <span className="text-[#4A148C]">talking.</span>
        </h2>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {reviews.map((r, i) => (
          <motion.figure
            key={r.name}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
            className="bg-white rounded-[28px] p-8 shadow-[0_16px_40px_-20px_rgba(43,11,60,0.18)]"
            data-testid={`review-card-${i}`}
          >
            <div className="flex gap-1 mb-5" aria-label="5 out of 5 stars">
              {Array.from({ length: 5 }).map((_, s) => (
                <Star key={s} size={15} className="fill-[#FF6B00] text-[#FF6B00]" />
              ))}
            </div>
            <blockquote className="font-display text-xl font-medium leading-snug text-[#2B0B3C]">
              "{r.quote}"
            </blockquote>
            <figcaption className="mt-6 text-sm font-bold text-[#2B0B3C]">
              {r.name}
              <span className="block text-xs font-medium text-[#2B0B3C]/50 mt-0.5">{r.detail}</span>
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </div>
  </section>
);
